import type { ChangeEvent } from 'react';
import { useCallback } from 'react';
import { useInstantSearch, useToggleRefinement } from 'react-instantsearch';
import { useIntl } from 'react-intl';
import styled from 'styled-components';

import { Checkbox } from '@sorare/core/src/atoms/inputs/Checkbox';
import { LabelM } from '@sorare/core/src/atoms/typography';
import { useEvents } from '@sorare/core/src/lib/events/useEvents';
import type { FilterWidget } from '@sorare/core/src/lib/filters';
import { TOGGLE_FILTERS } from '@sorare/core/src/lib/filters';

const FILTER = TOGGLE_FILTERS.jerseySerialFilter;

const Root = styled.label`
  display: flex;
  gap: var(--unit);
`;

const Filter = () => {
  const { formatMessage } = useIntl();
  const {
    value: { isRefined },
    refine,
  } = useToggleRefinement({
    attribute: FILTER.attribute,
  });
  const track = useEvents();
  const { indexUiState } = useInstantSearch();

  const handleChange = useCallback(
    (event: ChangeEvent<HTMLInputElement>) => {
      track('Use Market Filter', {
        filterName: FILTER.attribute,
        filterValue: event.target.checked.toString(),
      });

      refine({ isRefined });
    },
    [track, refine, isRefined]
  );

  const optimisticRefined = !!indexUiState.toggle?.[FILTER.attribute];

  return (
    <Root className="FilterWidget visible">
      <Checkbox noPadding checked={optimisticRefined} onChange={handleChange} />
      <LabelM color="var(--c-nd-600)">{formatMessage(FILTER.label!)}</LabelM>
    </Root>
  );
};

export const jerseySerialWidget: FilterWidget = {
  key: FILTER.attribute,
  type: 'toggle',
  attribute: FILTER.attribute,
  Component: Filter,
};
